module.exports = __webpack_public_path__ + "img/ezwrite6-platform-icon_windows.f5876901.svg";